import httpClient from './httpClient'

export default {
  async getDrm() {
    let ret = await httpClient.get('/drm')
    return ret
  },
  async getDrmGroups() {
    let ret = await httpClient.get('/drm/videos')
    return ret
  },
  async activateDrm() {
    let ret = await httpClient.post('/drm')
    return ret
  },
  async deactivateDrm() {
    let ret = await httpClient.delete('/drm')
    return ret
  },
  async createDrmGroup(body) {
    let ret = await httpClient.post('/drm/videos', body)
    return ret
  },
  async deleteDrmGroup(drmGroupId) {
    let ret = await httpClient.delete(`/drm/videos/${drmGroupId}`)
    return ret
  },
  async drmUpdateVideos(drmGroupId, updatedGroup) {
    let ret = await httpClient.put(`/drm/videos/${drmGroupId}`, updatedGroup)
    return ret
  },
  async getOneDrmPrivateToken(tokenId) {
    let ret = await httpClient.get(`/drm/tokens/${tokenId}`)
    return ret
  },
  async getDrmPrivateTokens(data) {
    let ret = await httpClient.get('/drm/tokens', {
      params: data,
    })
    return ret
  },
  async createDrmPrivateToken(body) {
    let ret = await httpClient.post('/drm/tokens', body)
    return ret
  },
  async drmUpdatePrivateToken(tokenId, updatedInfo) {
    let ret = await httpClient.put(`/drm/tokens/${tokenId}`, updatedInfo)
    return ret
  },
  async deleteDrmPrivateToken(tokenId) {
    let ret = await httpClient.delete(`/drm/tokens?id=${tokenId}`)
    return ret
  },
  async deleteMultipleDrmPrivateToken(tokenIds) {
    let ret = await httpClient.delete('/drm/tokens', {
      data: tokenIds,
    })
    return ret
  },
  async listGroupWebhooks(drmGroupId) {
    let ret = await httpClient.get(`/drm/videos/${drmGroupId}/webhook`)
    return ret
  },
  async updateGroupWebhook(data, drmGroupId) {
    let ret = await httpClient.post(`/drm/videos/${drmGroupId}/webhook`, data)
    return ret
  },
  async listSourceWebhooks(drmGroupId) {
    let ret = await httpClient.get(`drm/videos/${drmGroupId}/list_source`)
    return ret
  },
  async signJwtToken(drmGroupId) {
    let ret = await httpClient.get(`drm/videos/${drmGroupId}/jwt`)
    return ret
  },
}
